import "../../common/polyfills";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Elements, StripeProvider } from "react-stripe-elements";
import ACTMembershipForm from "./Components/ACTMembershipForm";

function MountACTMembershipForm(props: any, el: Element) {
	ReactDOM.render(
		<GoogleReCaptchaProvider reCaptchaKey={props.reCaptchaSiteKey}>
			<StripeProvider apiKey={props.publishableKey}>
				<Elements>
					<ACTMembershipForm {...props} />
				</Elements>
			</StripeProvider>
		</GoogleReCaptchaProvider>,
		el
	);
}

(window as any).MountACTMembershipForm = MountACTMembershipForm;
